// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@awc/App/Components/Common/XngZone";
import StyledShadowBox, { StyledShadowBoxStyles } from "@awc/XDL/Components/Common/ShadowBox";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

export interface MyAccountListPagesLayoutStyles {
    container?: InjectableCss;
    titleContainer?: InjectableCss;
    filterHeaderWidgetContainer?: InjectableCss;
    filtersContainer?: InjectableCss;
    topPaginationContainer?: InjectableCss;
    tableContainer?: InjectableCss;
    bottomPaginationContainer?: InjectableCss;
    splitter?: InjectableCss;
    shadowBox?: StyledShadowBoxStyles;
    countContainer?: InjectableCss;
}

export const myAccountListPagesLayoutStyles: MyAccountListPagesLayoutStyles = {};

const styles = myAccountListPagesLayoutStyles;
const MyAccountListPagesLayout: FC<WidgetProps> = ({ id, fields }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="My-Account-History-Pages-Layout">
            <StyledWrapper {...styles.titleContainer}>
                <XngZone contentId={id} zoneName="Content01" hint="Zone For Title" />
            </StyledWrapper>
            <StyledWrapper {...styles.filterHeaderWidgetContainer}>
                <XngZone contentId={id} zoneName="Content02" hint="Zone for Filters Header" />
            </StyledWrapper>
            {fields.showSplitter && <StyledWrapper {...styles.splitter} />}
            <StyledWrapper {...styles.countContainer}>
                <XngZone contentId={id} zoneName="Content07" hint="Zone for Count" />
            </StyledWrapper>
            <StyledShadowBox extendedStyles={styles.shadowBox} className="top-shadow-box">
                <XngZone contentId={id} zoneName="Content04" hint="Zone for pagination" />
            </StyledShadowBox>
            <StyledWrapper {...styles.tableContainer}>
                <XngZone contentId={id} zoneName="Content05" hint="Zone for Table" />
            </StyledWrapper>
            <StyledShadowBox extendedStyles={styles.shadowBox}>
                <XngZone contentId={id} zoneName="Content06" hint="Zone for Bottom Pagination" />
            </StyledShadowBox>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyAccountListPagesLayout,
    definition: {
        group: "Layout" as any,
        displayName: "My Account List Pages Layout",
        allowedContexts: [
            "OrderHistoryPage",
            "VmiOrderHistoryPage",
            "SavedOrderListPage",
            "OrderApprovalListPage",
            "RfqMyQuotesPage",
            "InvoiceHistoryPage",
            "MyListsPage",
        ],
        fieldDefinitions: [
            {
                name: "showSplitter",
                displayName: "Show Splitter Under The Tags",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: true,
            },
        ],
    },
};

export default widgetModule;
